import angular from 'angular';

// A clone of https://material.angularjs.org/latest/api/service/$mdMedia

// Breakpoints from `common/variables.less`
const MEDIA = {
  'xxs'   : '(max-width: 479px)',
  'gt-xxs': '(min-width: 480px)',
  'xs'    : '(min-width: 480px) and (max-width: 767px)',
  'gt-xs' : '(min-width: 768px)',
  'sm'    : '(min-width: 768px) and (max-width: 991px)',
  'gt-sm' : '(min-width: 992px)',
  'md'    : '(min-width: 992px) and (max-width: 1199px)' ,
  'gt-md' : '(min-width: 1200px)',
  'lg'    : '(min-width: 1200px)'
};

const MEDIA_PRIORITY = [
  'lg',
  'gt-md',
  'md',
  'gt-sm',
  'sm',
  'gt-xs',
  'xs',
  'gt-xxs',
  'xxs'
];

module.exports = angular.module('common.services.media-query', [])
.factory('$mediaQuery', function mediaQueryFactory($rootScope, $window) {
  var queries = {};
  var mqls = {};
  var results = {};
  var normalizeCache = {};

  $mediaQuery.getResponsiveAttribute = getResponsiveAttribute;
  $mediaQuery.getQuery = getQuery;
  $mediaQuery.watchResponsiveAttributes = watchResponsiveAttributes;

  return $mediaQuery;

  function $mediaQuery(query) {
    var validated = queries[query];
    if (angular.isUndefined(validated)) {
      validated = queries[query] = validate(query);
    }

    var result = results[validated];
    if (angular.isUndefined(result)) {
      result = add(validated);
    }

    return result;
  }

  function validate(query) {
    return MEDIA[query] ||
           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
  }

  function add(query) {
    var result = mqls[query];
    if ( !result ) {
      result = mqls[query] = $window.matchMedia(query);
    }

    result.addListener(onQueryChange);
    return (results[result.media] = !!result.matches);
  }

  function onQueryChange(query) {
    $rootScope.$evalAsync(function() {
      results[query.media] = !!query.matches;
    });
  }

  function getQuery(name) {
    return mqls[name];
  }

  function getResponsiveAttribute(attrs, attrName) {
    for (var i = 0; i < MEDIA_PRIORITY.length; i++) {
      var mediaName = MEDIA_PRIORITY[i];
      if (!mqls[queries[mediaName]].matches) {
        continue;
      }

      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
      if (attrs[normalizedName]) {
        return attrs[normalizedName];
      }
    }

    // fallback on unprefixed
    return attrs[getNormalizedName(attrs, attrName)];
  }

  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
    var unwatchFns = [];
    attrNames.forEach(function(attrName) {
      var normalizedName = getNormalizedName(attrs, attrName);
      if (angular.isDefined(attrs[normalizedName])) {
        unwatchFns.push(
            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
      }

      for (var mediaName in MEDIA) {
        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
        if (angular.isDefined(attrs[normalizedName])) {
          unwatchFns.push(
              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
        }
      }
    });

    return function unwatch() {
      unwatchFns.forEach(function(fn) { fn(); });
    };
  }

  // Improves performance dramatically
  function getNormalizedName(attrs, attrName) {
    return normalizeCache[attrName] ||
        (normalizeCache[attrName] = attrs.$normalize(attrName));
  }
})
.run(function($rootScope, $mediaQuery) {
  $rootScope.$mediaQuery = $mediaQuery;
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/media-query.js
 **/